import { env } from "../config";

export function getElapsedTime(timestamp: string): string {
  const now = new Date();
  const past = new Date(timestamp);
  const diffInSeconds = Math.floor((now.getTime() - past.getTime()) / 1000);

  if (diffInSeconds < 60) {
    return `${diffInSeconds} second${diffInSeconds === 1 ? "" : "s"} ago`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes} minute${diffInMinutes === 1 ? "" : "s"} ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours === 1 ? "" : "s"} ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return `${diffInDays} day${diffInDays === 1 ? "" : "s"} ago`;
  }

  const diffInWeeks = Math.floor(diffInDays / 7);
  if (diffInWeeks < 4) {
    return `${diffInWeeks} week${diffInWeeks === 1 ? "" : "s"} ago`;
  }

  const diffInMonths = Math.floor(diffInDays / 30); // Approximate average month length
  if (diffInMonths < 12) {
    return `${diffInMonths} month${diffInMonths === 1 ? "" : "s"} ago`;
  }

  const diffInYears = Math.floor(diffInMonths / 12);
  return `${diffInYears} year${diffInYears === 1 ? "" : "s"} ago`;
}

export function formatTimestampIST(timestamp: string): string {
  const date = new Date(timestamp);

  // Convert to IST by adding 5 hours and 30 minutes
  const ISTOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
  const ISTDate = new Date(date.getTime() + ISTOffset);

  const day = String(ISTDate.getUTCDate()).padStart(2, "0");
  const month = String(ISTDate.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = ISTDate.getUTCFullYear();

  const hours = String(ISTDate.getUTCHours()).padStart(2, "0");
  const minutes = String(ISTDate.getUTCMinutes()).padStart(2, "0");
  const seconds = String(ISTDate.getUTCSeconds()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} IST`;
}

export const isElapsedTimeLessThanThreshold = (timestamp: string): boolean => {
  const now = new Date();
  const past = new Date(timestamp);
  const diffInMinutes = (now.getTime() - past.getTime()) / 1000 / 60;
  return diffInMinutes < Number(env.RECENT_HIGHLIGHTED);
};
